<template>
  <b-navbar-nav v-show="isShown" class="bg-white ml-auto text-white z-20 d-lg-none">
    <div class="submenu-header">
      <b-nav-item class="text-white" @click.stop="close()">
        <div class="d-flex flex-column">
          <span class="back-link d-flex align-items-center font-bold mb-2">
            <fa-icon class="float-left mr-2" icon="fa-solid fa-chevron-left" />
            {{ $t('dp.navbar.backToMenu') }}
          </span>
          <span class="text-white text-left">{{ title }}</span>
        </div>
      </b-nav-item>
    </div>

    <slot />
  </b-navbar-nav>
</template>

<script>
export default {
  name: 'DpNavbarSubmenu',
  props: {
    isShown: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    baseLocaleUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style scoped lang="scss">
.submenu-header {
  width: 100vw;
  background: #003c71;
  color: white;
  margin-left: -1rem;
  padding-left: 1rem;

  .back-link {
    font-size: 14px;
    color: white;
  }
}
</style>
